<div class="flex min-h-[70vh] w-full items-center justify-center px-4 py-12">
  <div class="max-w-3xl rounded-lg bg-white p-8 shadow-lg">
    <div class="mb-8 text-center">
      <h1 class="mb-4 text-4xl font-bold text-grey-1" id="page-title">
        Sidan kunde inte hittas
      </h1>
      <p class="mb-6 text-lg text-grey-2">
        Sidan du letar efter kan ha tagits bort eller bytt adress.
      </p>

      <app-ui-button
        [color]="'green'"
        [compressed]="false"
        [linkTitle]="'Till startsidan'"
        [linkUrl]="'/'"
        [size]="'md'"
      >
        Till startsidan
      </app-ui-button>
    </div>

    <div class="mt-12 border-t border-grey-10 pt-8">
      <div class="flex flex-col items-center rounded-lg bg-duck-blue-10 p-6 text-center">
        <div class="mb-4 flex items-center justify-center">
          <app-ui-icon class="mr-2" color="var(--duck-blue-2)" name="bot" size="lg"></app-ui-icon>
          <h2 class="text-2xl font-bold text-duck-blue-2">Hittar du inte vad du söker?</h2>
        </div>
        <p class="mb-6 text-lg text-grey-1">
          Fråga vår AI-assistent om hjälp. Den kan svara på dina frågor om vård och hälsa.
        </p>

        <app-ui-button
          [color]="'green'"
          [compressed]="false"
          [linkTitle]="'Chatta med vår AI-assistent'"
          [linkUrl]="'https://chatt.varden.se/'"
          [size]="'lg'"
        >
          Chatta med vår AI-assistent
        </app-ui-button>
      </div>
    </div>
  </div>
</div>
